<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h5>
            <a href="/"
              ><i class="fa fa-chevron-right"></i> {{ $t("backToTheShop") }}</a
            >
          </h5>
          <hr />
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <p>
            &nbsp;<i v-if="cartUpdating" class="fas fa-spinner fa-spin"></i>
          </p>

          <cart-item-grid
            v-if="simple && cartItems.length > 0"
            :cart-items="cartItems"
            :dealer="cart.dealer"
            :persons="persons"
            :customerid="customerID"
            :affiliate="cart.affiliateID"
          />

          <div v-if="cart.totalNettExcVAT" class="cart-price-total">
            <div
              class="text-primary text-right"
              style="margin-right: 23px; font-weight: 400"
            >
              <div>{{ $t("subtotal") }}</div>
              <div>{{ $t("vat") }}</div>
              <div>{{ $t("total") }}</div>
            </div>
            <div class="text-right">
              <div>
                &euro;
                {{
                  (Math.round(cart.totalNettExcVAT * 100) / 100)
                    .toFixed(2)
                    .toString()
                    .replace(".", ",")
                }}
              </div>
              <div>
                &euro;
                {{
                  (
                    Math.round(
                      (cart.totalNettIncVAT - cart.totalNettExcVAT) * 100,
                    ) / 100
                  )
                    .toFixed(2)
                    .toString()
                    .replace(".", ",")
                }}
              </div>
              <div>
                &euro;
                {{
                  (Math.round(cart.totalNettIncVAT * 100) / 100)
                    .toFixed(2)
                    .toString()
                    .replace(".", ",")
                }}
              </div>
            </div>
          </div>
          <hr />
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-12">
          <b-form @submit.prevent="checkout">
            <cart-order-information
              v-if="groupedCartItems.length > 0 && loggedIn"
              :order-information="orderInformation"
              :transport-i-d="transportID"
              :paymethod-i-d="paymethodID"
              @update:orderInformation="orderInformation = $event"
            />

            <div v-if="cartItems.length > 0 && loggedIn" class="col-12 mb-3">
              <button
                class="btn btn-primary"
                :disabled="processing"
                type="submit"
              >
                <i v-if="processing" class="fas fa-spinner fa-spin"></i>
                {{ $t("createOrder") }}
              </button>
            </div>
          </b-form>

          <div
            v-if="!cartUpdating && groupedCartItems.length < 1"
            class="text-center w-100"
          >
            <h5>{{ $t("noCartItemsFound") }}</h5>
          </div>

          <div v-if="!loggedIn && cartItems.length > 0">
            <div class="text-center w-100">
              <h5>
                {{ $t("itLooksLikeYouAreCurrentlyNotLoggedInPlease") }}
                <a :href="`/${$store.state.language}/Register`">{{
                  $t("register")
                }}</a>
                {{ $t("or") }}
                <a
                  href="#"
                  data-bs-toggle="modal"
                  data-bs-target="#loginModal"
                  >{{ $t("login") }}</a
                >
                {{ $t("toContinue") }}
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CartItemGrid from "./CartItemGrid";
import CartOrderInformation from "./CartOrderInformation";
import {BForm} from "bootstrap-vue";
import {getDimensionObjects} from "@/services/dimension";
import sanitizeCartItems from "@/functions/sanitizeCartItems";
import {getGridSelectPersonList} from "../../util/person";
import {createOrder} from "../../services/cart";

export default {
  name: "ShopCart",
  components: {
    CartItemGrid,
    BForm,
    CartOrderInformation,
  },
  data: function () {
    return {
      selectedItemID: null,
      loaded: false,
      simple: true,
      processing: false,
      transportID: null,
      paymethodID: null,
      orderInformation: {
        ShippingIsSameAsInvoiceAddress: false,
      },
    };
  },
  computed: {
    cartLastUpdated() {
      return this.$store.getters.cartLastUpdated;
    },
    cart() {
      return this.$store.state.cart;
    },
    loggedIn: function () {
      return this.$store.getters.loggedIn;
    },
    cartItems: function () {
      return this.$store.getters.cartItems ?? [];
    },
    sanitizedCartItems: function () {
      if (this.cartItems?.length > 0) {
        return sanitizeCartItems(this.cartItems);
      }
      return [];
    },
    groupedCartItems: function () {
      let groupedItemList = [];
      if (this.$store.state.cart.groupedCartItems) {
        groupedItemList = Object.keys(
          this.$store.state.cart.groupedCartItems,
        ).map((key) => this.$store.state.cart.groupedCartItems[key]);
      }

      return groupedItemList;
    },
    persons: function () {
      if (
        this.$store.getters.persons === null ||
        this.$store.getters.persons === undefined
      )
        return [];
      return getGridSelectPersonList({
        persons: this.$store.getters.persons,
      });
    },
    cartUpdating: function () {
      return this.$store.state.cartUpdating;
    },
    customerID: function () {
      return this.$store.state.customerID;
    },
  },
  watch: {
    cartLastUpdated() {
      this.$store.dispatch("updateCart");
    },
    cart: {
      handler(cart) {
        this.transportID = cart.transportID ?? null;
        this.paymethodID = cart.paymethodID ?? null;
      },
      deep: true,
    },
  },
  async created() {
    const customerField = document.getElementsByName("customerid");

    this.$store.commit("setCustomerID", {
      customerID: customerField[0]?.value ?? null,
    });
    this.$store.dispatch("updateCart");

    if (this.customerID) {
      await this.getPersons();
    }
    this.orderInformation.transportID = this.cart.transportID ?? null;
    this.loaded = true;
  },
  methods: {
    checkout: async function () {
      this.processing = true;
      const result = await createOrder({
        orderInformation: {...this.orderInformation},
      });

      if (result.data.ExceptionLevel === "DANGER") {
        this.$toasted.show(result.data.Message);
      }

      if (result.data.success === false) {
        this.$toasted.show(result.data.message);
      }

      if (result.data.success && result.data.paymentUrl) {
        window.location.href = result.data.paymentUrl;
        return;
      }

      if (result.data.orderID) {
        window.location.href = `/${this.$store.state.language}/checkout/complete?OrderID=${result.data.orderID}`;
      }

      this.processing = false;
    },
    updateCart() {
      this.$store.dispatch("updateCart");
    },
    async getPersons() {
      const persons = await getDimensionObjects({
        dimensionID: 3,
        customerID: this.$store.state.customerID ?? null,
      });
      this.$store.commit("setPersons", {persons});
    },
  },
};
</script>
<style lang="scss">
.cart-price-total {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.input-box {
  padding: unset;
  margin: unset;
  min-height: unset;
}

.grid-select {
  width: 100%;
  margin: unset;
  padding: unset;
  height: unset;
}
.cell .editable-field input {
  margin: unset;
  padding: unset;
}
.cart-item-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}

th[name="Total"] {
  text-align: right;
}

th[name="Price"] {
  text-align: right;
}

th[name="Qty"] {
  text-align: right;
}
</style>
